import { render, staticRenderFns } from "./InputFormulario.vue?vue&type=template&id=6ff45e7a&"
import script from "./InputFormulario.vue?vue&type=script&lang=js&"
export * from "./InputFormulario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WInput from '@/components/WInput.vue'
autoInstallComponents(component, {WInput})
